import React, { useEffect, useState } from "react";
import { Button, Divider } from "@mui/material";
import { Col, Row } from "reactstrap";
import dayjs from "dayjs";
import moment from "moment";
import { useSSR } from "react-i18next";
import QRCode from "qrcode.react";
import { useLocation, useParams } from "react-router-dom";
import GuamImage from "../../../../src/assets/images/GuamSeal.png"
// import { renderNumberFormat } from "../../utils/rendernumber";

const PaybreakModal = ({ earningsList, loading, data }) => {
  const [ehrpDigit, seteHRPDigit] = useState(0);
  const [legacyDigit, setLegacyDigit] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  let totalA = 0;
  useEffect(() => {
    earningsList?.map((item) => {
      totalA = totalA + (item.amount ? item.amount : 0);
    });
    setTotalAmount(totalA);
  }, [earningsList]);

  // function findMaxDigitsAmongFields(data, fields) {
  //   let maxDigits = 0;

  //   data &&
  //     data.length > 0 &&
  //     data.forEach((item) => {
  //       fields.forEach((field) => {
  //         const value = item[field];
  //         if (typeof value === "number") {
  //           const numDigits = value.toString().replace(".", "").length;
  //           if (numDigits > maxDigits) {
  //             maxDigits = numDigits;
  //           }
  //         }
  //       });
  //     });

  //   return maxDigits;
  // }
  // useEffect(() => {
  //   if (earningsList && earningsList.length > 0) {
  //     seteHRPDigit(findMaxDigitsAmongFields(earningsList, ["eHRPAmount"]));
  //     setLegacyDigit(findMaxDigitsAmongFields(earningsList, ["legacyAmount"]));
  //     setdeltaDigit(findMaxDigitsAmongFields(earningsList, ["deltaAmount"]));
  //   }
  // }, [earningsList]);
  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image"></div>
      <div className="k-loading-color"></div>
    </div>
  );
  const location = useLocation()


  // const finalURL = `${process.env.REACT_APP_PUBLIC_URL}${location.pathname}${location.search}`

  return (
    <div
      className="payrollRunTaxDetailModal"
    // style={{ padding: '0', width: 700 }}
    >
      <Row>
        <Col lg={2} sm={2} md={2} style={{textAlign:"center"}}>
          <img src={GuamImage} width='65px' className="ms-2 mt-2" alt="" />
        </Col>
        <Col lg={8} sm={8} md={8}>
          <Row>
            <Col lg={12} sm={12} md={12} style={{ textAlign: "center", fontSize: "1.2rem" }}>
              <b>{data?.employeeInfo?.departmentName}</b>
              <h6>{data?.employeeInfo?.employeePositionTitle}</h6>
            </Col>
            <Col lg={12} sm={12} md={12} style={{ display: "flex", justifyContent: "center" }}>


              {data.StartDate && data.EndDate ? (
                <div style={{ display: "flex" }}>
                  <p>
                    {" "}
                    <b>Pay Period</b>
                    - {moment(data.StartDate).format("MM/DD/YYYY")}
                  </p>
                  <p style={{ marginLeft: "10px", marginRight: "10px" }}> <b>To</b> </p>
                  <p>{moment(data.EndDate).format("MM/DD/YYYY")}</p>
                </div>
              ) : (
                ``
              )}
            </Col>
            <Col lg={12} sm={12} md={12} style={{ display: "flex", justifyContent: "center" }}>


              
                <div style={{ display: "flex" }}>
                  <p>
                    {" "}
                    <b>Employee Name </b>
                    -  {data?.EmployeeName}
                  </p>
                  
                </div>
              
            </Col>
            <Col lg={12} sm={12} md={12} style={{ display: "flex", justifyContent: "center" }}>


              
                <div style={{ display: "flex" }}>
                  <p>
                    {" "}
                    <b>Employee No </b>
                    -  {data?.userId}
                  </p>
                  
                </div>
              
            </Col>
            {/* <Col lg={12} sm={12} md={12} style={{ textAlign: "center" }}>
              {data?.EmployeeName}
            </Col> */}
          </Row>
          {/* <Row>
            <Col lg={4} style={{ textAlign: "left" }}>
              Employee Name -
            </Col>
          </Row> */}
        </Col>
        <Col lg={2} sm={2} md={2} style={{ textAlign: "center" }}>

          <QRCode
            id="qr-gen"
            value={window?.location?.href}
            size={100}
            level={"H"}
            includeMargin={true}
          />
          {/* <div>ID : {data?.userId}</div> */}
        </Col>

      </Row>

      {/* {selectedData?.DepartmentName && (
        <Row>
          <Col xl={4} lg={4}>
            <h6 className="detailHeader">Department Name - </h6>
          </Col>
          <Col xl={8} lg={8}>
            <p>{selectedData?.DepartmentName}</p>
          </Col>
        </Row>
      )} */}
      {/* {selectedData?.DepartmentDivision && (
        <Row>
          <Col xl={4} lg={4}>
            <h6 className="detailHeader">Department Division - </h6>
          </Col>
          <Col xl={8} lg={8}>
            <p>{selectedData?.DepartmentDivision}</p>
          </Col>
        </Row>
      )} */}
      <Divider style={{ margin: "1%" }} />
      {/* <>
        <div
          style={{
            minHeight: "25vh",
            maxHeight: "25vh",
            overflowX: "hidden",
            overflowY: "scroll",
          }}
        >
          {loading ? (
            loadingPanel
          ) : (
            <>
              <Row>
                <Col xl={4} lg={4}></Col>
             
                <Col xl={1} lg={1} className="text-center"></Col>
                <Col xl={3} lg={3}>
                  eHRP Amount
                </Col>
              </Row>
              {earningsList &&
                earningsList?.length > 0 &&
                earningsList
                  .filter((i) => i.category !== null)
                  .map((o, i) => {
                    return (
                      <Row>
                        <Col xl={4} lg={4}>
                          <p>{o?.category} :</p>
                        </Col>

                        <Col xl={1} lg={1} className="text-center"></Col>
                        <Col
                          xl={2}
                          lg={2}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>$</div>
                          <div>{o?.amount ? o.amount : 0}</div>
                        </Col>
                      </Row>
                    );
                  })}
            </>
          )}
        </div>

        <Divider style={{ margin: "3%" }} />

        <div
          style={{
            overflowY: "scroll",
          }}
        >
          <Row>
            <Col xl={4} lg={4}>
              <h6>Net Pay:</h6>
            </Col>
            <Col xl={1} lg={1}></Col>
            <Col xl={1} lg={1}></Col>
            <Col
              xl={2}
              lg={2}
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <h6>$</h6>
              <h6>{earningsList?.length ? totalAmount : 0}</h6>
            </Col>
            <Col xl={2} lg={2}></Col>
            <Col xl={2} lg={2}></Col>
          </Row>
        </div>
      </> */}
    </div>
  );
};

export default PaybreakModal;
